import styled from "styled-components";

import { Card, media } from "@otta/design";
import { palette, pxToRem } from "@otta/design-tokens";

export const CarouselCard = styled(Card)`
  border: 1px solid ${palette.grayscale.shade100};
  margin: auto;
  ${media({ from: "desktop" })`
    width: ${pxToRem(512)};
  `}
`;
